import { Stat, StatGroup } from '@vnetwork/ui/data';
import { Card, CardBody } from '@vnetwork/ui/primitives';
import { formatMoney } from '@/lib/format';
import type { RevenueCombinedSummary } from '@/api/customer-revenue';

interface RevenueAllocationStatCardsProps {
  summary: RevenueCombinedSummary | undefined;
}

/**
 * Five summary stat cards for the Revenue Allocation tab.
 * Values come from the `summary` side-car on the revenue-combined envelope.
 * Mirrors the legacy StatisticsCards component using real @ui Stat + StatGroup.
 */
export function RevenueAllocationStatCards({ summary }: RevenueAllocationStatCardsProps) {
  const allocated = summary?.total_allocated_amount ?? 0;
  const actual = summary?.total_actual_amount ?? 0;
  const projected = summary?.total_projected_amount ?? 0;
  const paid = summary?.total_paid_amount ?? 0;
  const unpaid = summary?.total_unpaid_amount ?? 0;

  return (
    <Card flat>
      <CardBody>
        <StatGroup columns={5}>
          <Stat
            label="Total Allocated"
            value={formatMoney(allocated)}
            dotColor="var(--vn-primary-solid)"
          />
          <Stat
            label="Total Actual"
            value={formatMoney(actual)}
            dotColor="var(--vn-success-solid)"
          />
          <Stat
            label="Total Projected"
            value={formatMoney(projected)}
            dotColor="var(--vn-warning-solid)"
          />
          <Stat
            label="Paid"
            value={formatMoney(paid)}
            dotColor="var(--vn-info-solid)"
          />
          <Stat
            label="Unpaid"
            value={formatMoney(unpaid)}
            dotColor="var(--vn-danger-solid)"
          />
        </StatGroup>
      </CardBody>
    </Card>
  );
}
